import { Component } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  visibility:boolean= false;
  loginVisible:boolean =true;
  ngOnInit(): void {
    this.visibility = true
    /*setTimeout(function(){
      $('.network-status').animate({right:10},350);
    },5000);
    setTimeout(function(){
      $('.network-status .network-icon').removeClass('down').addClass('up');
    },5500);
    setTimeout(function(){
      $('.network-status').animate({right:-500},350);
    },8000);*/
  }
  
}
